import { config as devToolsConfig } from "./config";
import { IS } from "./util";

export function disableKeyAndMenu(status: boolean) {
  const top = window.top;
  let parent = window.parent;
  disableTarget(status, window);
  
  if (!devToolsConfig.disableIframeParents || !top || !parent || top === window) {
    return;
  }
  while (parent !== top) {
    disableTarget(status, parent);
    parent = parent.parent;
  }
  disableTarget(status, top);
}

function disableTarget(status: boolean, target: Window) {
  if (status) {
    target.addEventListener('keydown', keyDownListener, true);
    return;
  }
  target.removeEventListener('keydown', keyDownListener, true);

  // disableMenu(target);
  // disableSelect(target);
  // disableCopy(target);
  // disableCut(target);
  // disablePaste(target);
}

function keyDownListener(this: Window, e: KeyboardEvent) {
  e = e || this.event;
  const keyCode = e.keyCode || e.which;
  if (
    keyCode === KEY.F12 ||            // 禁用 F12
    isOpenDevToolKey(e, keyCode) ||   // 禁用 ctrl + shift + i
    isViewSourceCodeKey(e, keyCode)   // 禁用 ctrl + u 和 ctrl + s 查看和保存
  ) {
    return preventEvent(this, e);
  }
  return;
}

// let key1 = 'shiftKey', key2 = 'ctrlKey';
// 'metaKey'; // mac 的 commond
// 'altKey';  // mac 的 option
const KEY = { J: 74, I: 73, U: 85, S: 83, F12: 123 };

// 禁用 ctrl + shift + i/j
function isOpenDevToolKey(e: KeyboardEvent, code: number): boolean {
  return IS.macos ? (e.metaKey && e.altKey && (code === KEY.I || code === KEY.J)) : (e.ctrlKey && e.shiftKey && (code === KEY.I || code === KEY.J));
}

function isViewSourceCodeKey(e: KeyboardEvent, code: number): boolean {
  return IS.macos ? (e.metaKey && e.altKey && code === KEY.U) || (e.metaKey && code === KEY.S) : (e.ctrlKey && (code === KEY.S || code === KEY.U));
}

// function disableMenu(target: Window) {
//   if (devToolsConfig.disableMenu) {
//     addPreventListener(target, 'contextmenu');
//   }
// }
// function disableSelect(target: Window) {
//   if (devToolsConfig.disableSelect) {
//     addPreventListener(target, 'selectstart');
//   }
// }
// function disableCopy(target: Window) {
//   if (devToolsConfig.disableCopy) {
//     addPreventListener(target, 'copy');
//   }
// }
// function disableCut(target: Window) {
//   if (devToolsConfig.disableCut) {
//     addPreventListener(target, 'cut');
//   }
// }
// function disablePaste(target: Window) {
//   if (devToolsConfig.disablePaste) {
//     addPreventListener(target, 'paste');
//   }
// }
// function addPreventListener(target: Window, name: string) {
//   target.addEventListener(name, (e: Event) => {
//     return preventEvent(target, e);
//   });
// }

function preventEvent(target: Window, e: Event) {
  e = e || target.event;
  e.returnValue = false;
  e.preventDefault();
  return false;
}